(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ImageStorageDialogController', ImageStorageDialogController);

    ImageStorageDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'DataUtils', 'entity', 'ImageStorage'];

    function ImageStorageDialogController ($timeout, $scope, $uibModalInstance, DataUtils, entity, ImageStorage) {
        var vm = this;

        vm.imageStorage = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.imageStorage.id !== null) {
                ImageStorage.update(vm.imageStorage, onSaveSuccess, onSaveError);
            } else {
                ImageStorage.save(vm.imageStorage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:imageStorageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setData = function ($file, imageStorage) {
            vm.imageStorage.name = $file.name;
            if (vm.imageStorage.name.length > 50) {
                vm.imageStorage.name = vm.imageStorage.name.substring(vm.imageStorage.name.length - 50);
            }
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        imageStorage.data = base64Data;
                        imageStorage.dataContentType = $file.type;
                    });
                });
            }
        };

    }
})();
